<template>
  <v-container class="pa-4" fluid>
    <v-card outlined class="pa-4 mx-auto" max-width="500">
      <v-form ref="form" lazy-validation>
        <!-- Fecha del periodo -->
        <v-menu
          v-model="menuFecha"
          transition="scale-transition"
          offset-y
          max-width="290"
          min-width="290"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="mesActualTexto"
              label="Periodo"
              readonly
              outlined
              v-bind="attrs"
              v-on="on"
              prepend-inner-icon="mdi-calendar-month"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="egreso.fechaPeriodo"
            type="month"
            locale="es"
            no-title
            scrollable
            @input="menuFecha = false"
            :max="moment().format('YYYY-MM-DD')"
          ></v-date-picker>
        </v-menu>

        <!-- Total -->
        <v-text-field
          class="mt-4"
          outlined
          v-model="egreso.monto"
          v-validate="'required|numeric|max:10'"
          :error-messages="errors.collect('total')"
          data-vv-name="total"
          label="Total"
          prefix="$"
          type="number"
          required
        ></v-text-field>

        <!-- Categoría -->
        <GastosFormCategoria class="mt-4" :egreso="egreso" />

        <!-- Tipo de gasto -->
        <v-select
          class="mt-4"
          v-model="egreso.tipoIngresoEgreso"
          :items="tiposIngresoEgreso"
          no-data-text="No hay tipos de egresos registrados"
          outlined
          item-text="descripcion"
          item-value="descripcion"
          return-object
          label="Tipo de gasto"
          hint="Detalle dentro de la categoría, ej: Luz, Agua, Internet"
          persistent-hint
          v-validate="'required'"
          :error-messages="errors.collect('tipoEgreso')"
          data-vv-name="Tipo de gasto"
        ></v-select>

        <!-- Comentarios -->
        <v-textarea
          class="mt-4"
          outlined
          label="Comentarios"
          v-model="egreso.descripcion"
          placeholder="Comentarios"
          maxlength="100"
          :counter="100"
          v-validate="'max:100'"
          :error-messages="errors.collect('comentarios')"
        ></v-textarea>

        <!-- Forma de pago: solo aplica si el próximo paso no es "pagar con caja" -->
        <v-select
          class="mt-4"
          v-model="egreso.formaDePago"
          :items="formasDePago"
          no-data-text="No hay formas de pago configuradas para esta sucursal"
          outlined
          item-text="nombre"
          item-value="nombre"
          return-object
          label="Forma de pago"
          hint="Si vas a pagar con dinero de la caja no hace falta elegir; si no, indicá cómo se pagó (transferencia, tarjeta, etc.)"
          persistent-hint
          clearable
        ></v-select>
      </v-form>
      <v-card-actions>
        <v-btn
          block
          large
          color="success"
          :disabled="!validRegister"
          @click="$emit('process:register')"
        >
          {{ textButton }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import GastosFormCategoria from "@/views/pos/egresos/components/GastosFormCategoria.vue";

export default {
  name: "EgresoForm",
  inject: ["$validator"],
  components: { GastosFormCategoria },
  props: {
    egreso: { type: Object, required: true },
    textButton: {
      type: String,
      required: false,
      default: "Registrar",
    },
  },
  data() {
    return {
      tiposIngresoEgreso: [],
      formasDePago: [],
      menuFecha: false,
    };
  },
  computed: {
   mesActualTexto() {
    if (!this.egreso.fechaPeriodo) return "";
    
    // Usamos moment para parsear el string 'YYYY-MM'
    // .format('MMMM YYYY') devolverá algo como "marzo 2026"
    return this.moment(this.egreso.fechaPeriodo).format('MMMM YYYY');
  },
    validRegister() {
      return (
        this.egreso.tipoIngresoEgreso &&
        this.egreso.categoria &&
        (this.egreso.monto > 0 || this.egreso.detalles.length > 0)
      );
    },
  },
  methods: {
    async fetchTipos() {
      const response = await this.axios.get(
        "/egresos/tipoingresoegreso?esIngreso=False"
      );
      this.tiposIngresoEgreso = response.data;
    },
    async fetchFormasDePago() {
      const response = await this.axios.get("/comprobantes/formaDePago");
      this.formasDePago = response.data;
    },
  },
  created() {
    this.fetchTipos();
    this.fetchFormasDePago();
    if (!this.egreso.fechaPeriodo)
      this.egreso.fechaPeriodo = new Date().toISOString().substr(0, 10);
  },
};
</script>

<style lang="scss" scoped>
.v-card {
  border-radius: 12px;
}
</style>
